
import React, { useEffect } from 'react';

interface CarouselAnalyticsProps {
  psychologists: Array<{ id: string; name: string }>;
}

const CarouselAnalytics = ({ psychologists }: CarouselAnalyticsProps) => {
  
  // Registrar impressão do carousel
  useEffect(() => {
    if (psychologists.length > 0) {
      // Analytics event para impressão
      const analyticsData = {
        event: 'carousel_impression',
        timestamp: new Date().toISOString(),
        psychologist_count: psychologists.length,
        psychologist_ids: psychologists.map(p => p.id)
      };
      
      // Enviar para analytics (pode ser Google Analytics, Mixpanel, etc.)
      console.log('📊 Carousel Analytics - Impression:', analyticsData);
      
      // Exemplo de integração com API interna
      fetch('/api/analytics/events', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(analyticsData)
      }).catch(err => console.log('Analytics error:', err));
    }
  }, [psychologists]);

  // Função para rastrear cliques
  const trackCarouselClick = (psychologistId: string, action: 'view_profile' | 'book_appointment') => {
    const analyticsData = {
      event: 'carousel_click',
      timestamp: new Date().toISOString(),
      psychologist_id: psychologistId,
      action: action,
      user_agent: navigator.userAgent
    };
    
    console.log('📊 Carousel Analytics - Click:', analyticsData);
    
    fetch('/api/analytics/events', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(analyticsData)
    }).catch(err => console.log('Analytics error:', err));
  };

  // Disponibilizar função globalmente para uso nos botões
  useEffect(() => {
    (window as any).trackCarouselClick = trackCarouselClick;
    
    return () => {
      delete (window as any).trackCarouselClick;
    };
  }, []);

  return null; // Componente invisível para analytics
};

export default CarouselAnalytics;
